import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZData = z.object({
  alarmId: z.string(),
  alarmLabelId: z.string().nullable(),
  parameterId: z.string().optional(),
  alarmLabelName: z.string(),
  severity: z.string(),
  status: z.string(),
  returnToNormal: z.string(),
  hierarchy: z.string(),
  lastReadingTime: z.string(),
  assetName: z.string(),
  parameterName: z.string(),
  colorValue: z.string(),
  currentValue: z.number(),
  setPoint: z.number(),
  recommendedActions: z.string().nullable(),
  acknowledged: z.boolean(),
  alarmRaisedAt: z.string(),
  rtnRaisedAt: z.string()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZData).optional()
})

export type AlertsNotificationDetails = z.infer<typeof ZData>
export type AlertsNotificationAPIData = z.infer<typeof ZApiResponse>

export async function getNotificationByFilter (
  siteId: string,
  assetIds: string,
  deviceIds: string,
  severities: string,
  alertStatus: string,
  alarmLabelIds: string,
  sortOrder: string,
  onSuccess: (AlertsCountDetails: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const formatIds = (ids: string): string[] => ids.split(',').map(id => id.trim())

  const requestParam = {
    siteId,
    assetIds: assetIds !== undefined && assetIds !== null && assetIds !== '' ? formatIds(assetIds) : [],
    deviceIds: deviceIds !== undefined && deviceIds !== null && deviceIds !== '' ? formatIds(deviceIds) : [],
    severities: severities !== undefined && severities !== null && severities !== '' ? formatIds(severities) : [],
    alertStatus: alertStatus !== undefined && alertStatus !== null && alertStatus !== '' ? formatIds(alertStatus) : [],
    alarmLabelIds: alarmLabelIds !== undefined && alarmLabelIds !== null && alarmLabelIds !== '' ? formatIds(alarmLabelIds) : [],
    sortOrder
  }
  const url = `/alarm-service/api/v1/udp/tiq/assets/alerts/notificationDetails/${siteId}`
  interceptedAxios
    .post(url, requestParam, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
